module.exports = __webpack_public_path__ + "img/softwood.6e4a2fea.png";